import { HttpService } from "../core/http";
import { Injectable } from '@angular/core';
import { IContract, IStore } from '../_entities';
import { DataAccessServiceBase } from "./dataaccess.base.service";
import { ModelStateValidationService } from "./model-state-validation.service";
import { CrudOperation } from "../_entities/data";

@Injectable()
export class ContractService extends DataAccessServiceBase<IContract> {
  
    constructor(protected httpService: HttpService,
        protected validationService: ModelStateValidationService) {
        super(httpService, validationService);
    }

    getControllerUrl(): string {
        return "api/contract";
    }

    getContracts(storeId: number): Promise<IContract[] | any> {
		return this.httpService.get<IContract[]>(`api/store/${storeId}/contract`)
            .catch(e => {
                this.validationService.handleError(e);
            });
	}

	getContract(id: number): Promise<IContract> {
		return this.httpService.get<IContract>(`api/contract/${id}`);
	}

	getCentralContracts(typeId?: number): Promise<IContract[]> {
		if (!!typeId) {
			return this.httpService.get<IContract[]>(`api/central-contract/type/${typeId}`);
		} else {
			return this.httpService.get<IContract[]>(`api/central-contract`);
		}
	}

	getCentralContractEffectiveCoverage(id: number): Promise<IStore[]> {
		return this.httpService.get<IStore[]>(`api/central-contract/${id}/effective-coverage`);
	}


	getContractNotifications() {
		return this.httpService.get<IContract[]>(`api/contract/notificationreport`);
	}


	addBreakClause(contractId: number): Promise<any> {
		return this.httpService.post<any>(`api/contract/${contractId}/contractbreakclause`, {});
	}

	patchBreakClause = (id: number, prop: string, value: any) => this.httpService.patch<any>(`/api/contractbreakclause/${id}`, [{ "op": "replace", "path": `/${prop}`, "value": value }]);

	deleteBreakClause = (id: number) => this.httpService.delete<any>(`/api/contractbreakclause/${id}`);


	async addIfrsReportRebate(contract: IContract, contractId: number, date: string) {
		const rebate = await this.httpService.post<any>(`api/contract/${contractId} /ifrsreportrebate`, { startDate: date });

		//console.log("addIfrsReportRebate", contract.ifrs2);

		//const newRebate = contract.ifrs2.contractIfrsRebates.find(x => !x.id);
		//newRebate.id = rebate.id;
		//newRebate.startDate = rebate.startDate;

		this.itemChanged.emit({ operation: CrudOperation.Update, data: contract });
		return rebate;
	}
	async updateIfrsReportRebate(contract: IContract, contractId: number, id: number, data: any) {
		const rebate = await this.httpService.put<any>(`api/contract/${contractId}/ifrsreportrebate/${id}`, data);
		this.itemChanged.emit({ operation: CrudOperation.Update, data: contract });
		return rebate;
	}
	async patchIfrsReportRebate(contract: IContract, id: number, prop: string, newValue: any, oldValue: any) {
		const rebate = await this.httpService.patch<any>(`api/contract/${contract.id}/ifrsreportrebate/${id}`, [{ "op": "replace", "path": `/${prop}`, "value": newValue }]);
		this.itemChanged.emit({ operation: CrudOperation.Update, data: contract, newValue: newValue, oldValue: oldValue, fieldName: prop });
		return rebate;
	}

	async deleteIfrsReportRebate(contract: IContract, contractId: number, id: number) {
		await this.httpService.delete<any>(`api/contract/${contractId}/ifrsreportrebate/${id}`);
		this.itemChanged.emit({ operation: CrudOperation.Update, data: contract });
	}

	async patchIfrsReportForecastYear(contract: IContract, yearNumber: number, prop: string, newValue: any, oldValue: any) {
		const rebate = await this.httpService.patch<any>(`api/contract/${contract.id}/ifrsreportforecastYear/${yearNumber}`, [{ "op": "replace", "path": `/${prop}`, "value": newValue }]);
		this.itemChanged.emit({ operation: CrudOperation.Update, data: contract, newValue: newValue, oldValue: oldValue, fieldName: prop });
		return rebate;
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/contract.service.ts